import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { connect } from 'react-redux'
import Linkify from 'linkify-react'
import { highlightAlertKeywords } from '../helpers/highlightAlertKeywords'
import moment from 'moment-timezone'
import ReactTooltip from 'react-tooltip'
import DateFormatter from '../Classes/DateFormatter'
import { formatPhoneNatOrIntl } from '../redux/FeedbackRedux'

/**
 * HTML-escape a value for safe interpolation into tooltip markup rendered via
 * react-tooltip's `html={true}` (internal dangerouslySetInnerHTML). Encodes quotes
 * too, so it is safe in both text and attribute (e.g. href="...") contexts.
 */
function escapeHtml (str) {
    if (str == null) return ''
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}

class Chat extends React.Component {
    decodeHightlight(query, text) {
        if (query === "") return text;
        return text.replace(new RegExp(query + '(?!([^<]+)?>)', 'g'), `<span class="highlighted">${query}</span>`)
    }

    attachmentClicked(event, public_url) {
        const image_pattern = /\.(png|jpg|jpeg|gif)$/i;
        const video_pattern = /\.(mp4|avi|mov|wmv|flv|mkv)$/i;
        if (!image_pattern.test(public_url) && !video_pattern.test(public_url)) return;
        event.preventDefault();
        const src = public_url;
        if (image_pattern.test(public_url)) {
            const img = `
            <div class="d-flex w-100 h-100 attachment-modal">
            <img src="` + src + `" class="attachment"  alt="" />
            <span class="close close-attachment cursor-pointer text-white">x</span>
            </div>
            `;
            jQuery('body').append(img);
        } else {
            const video = `
            <div class="d-flex w-100 h-100 attachment-modal">
            <video class="attachment" controls><source src=${src} type="video/mp4"/></video>
            <span class="close close-attachment cursor-pointer text-white">x</span>
            </div>
            `;
            jQuery('body').append(video);
        }

    }

    render() {

        let chat_red_text;

        const formattedDate = moment(this.props.chat.created_at).tz(this.props.state.business.call_at_timezone)
        const formattedDateOnly = DateFormatter.formatDateOnly(this.props.chat.created_at, this.props.state.business.call_at_timezone, this.props.state.app_locale);

        let name = null;
        const isAutoResponse = this.props.isAutoResponse;
        const sender = this.props.chat.sender
        // Always show the sender's full name (title is shown separately in the header above the bubble).
        const fullName = sender ? ((sender.firstname ?? '') + ' ' + (sender.lastname ?? '')).trim() : ''
        const senderDisplayName = sender ? (fullName || sender.title || 'User') : 'User'
        const isOutgoing = this.props.chat.sender_id !== this.props.state.feedback_detail.user_id
        if (isOutgoing) {
            if (this.props.chat.message_source === 'ai') {
                name = '';
            } else if (isAutoResponse) {
                name = "Feedback Auto-response";
            } else {
                name = senderDisplayName
            }
        } else {
            if (this.props.hidename) {
                name = "Hidden";
            } else {
                name = senderDisplayName
            }
        }

        let classes = [];
        if (isOutgoing) {
            classes = ['outgoing_msg', 'outgoing_info', 'outgoing_msg_img', 'outgoing_msg_txt mx-2', 'sent_msg'];
        } else {
            classes = ['incoming_msg', 'incoming_info', 'incoming_msg_img', 'incoming_msg_txt mx-2', 'received_msg'];
        }

        let initial_span;
        if (classes[0] === "outgoing_msg" || (classes[0] === "incoming_msg" && !this.props.hidename)) {
            if (isAutoResponse) {
                initial_span = <span className="user_initials autoresponse"><i className="fas fa-robot"></i></span>;
            } else {
                initial_span = <span className="user_initials">
                    {this.props.chat.sender && this.props.chat.sender.firstname ? (this.props.chat.sender.firstname.substring(0, 1) + (this.props.chat.sender.lastname ? this.props.chat.sender.lastname.substring(0, 1) : "")).toUpperCase() : "?"}
                </span>;
            }
        } else {
            initial_span = <span className="user_initials">H</span>;
        }

        if (this.props.red_alerts_list) {
            const keywords = this.props.red_alerts_list;
            if (keywords) {
                chat_red_text = highlightAlertKeywords(ReactDOMServer.renderToStaticMarkup(<Linkify
                    options={{target: '_blank'}}>{this.props.chat.message}</Linkify>), keywords);
            }
        }

        // Contact tooltip on the header (title + initials) — outgoing agent/employee messages only,
        // never for auto-response/AI or incoming customer messages.
        const showContactTooltip = isOutgoing && !isAutoResponse && sender && (fullName || sender.phone || sender.email)
        let tooltipHtml = ''
        const tooltipId = `chat-sender-${this.props.id}`
        if (showContactTooltip) {
            const tooltipLines = []
            if (fullName) {
                tooltipLines.push(`<strong>${escapeHtml(fullName)}</strong>`)
            }
            if (sender.title) {
                tooltipLines.push(escapeHtml(sender.title))
            }
            if (sender.phone) {
                tooltipLines.push(escapeHtml(formatPhoneNatOrIntl(sender.phone)))
            }
            if (sender.email) {
                tooltipLines.push(`<a href="mailto:${escapeHtml(sender.email)}" style="color:#8ecbff">${escapeHtml(sender.email)}</a>`)
            }
            tooltipHtml = `<div style="text-align:left">${tooltipLines.join('<br/>')}</div>`
        }

        const senderHeader = (
            <React.Fragment>
                <div className={classes[2]}>
                    {initial_span}
                </div>
                <div className={classes[3]}>
                    {sender ? sender.title : 'Auto'}
                </div>
            </React.Fragment>
        )

        return (
            <div className="chat_widget_body">
                <div className={classes[0]}>
                    <div className={classes[1]}>
                        {showContactTooltip ? (
                            <span
                                className="chat_sender_header"
                                style={{ display: 'inline-flex', flexDirection: 'row-reverse', alignItems: 'center' }}
                                data-tip={tooltipHtml}
                                data-tooltip-html={tooltipHtml}
                                data-for={tooltipId}
                            >
                                {senderHeader}
                            </span>
                        ) : senderHeader}
                    </div>
                    {showContactTooltip && (
                        <ReactTooltip id={tooltipId} html={true} className="tooltip-content" effect="solid" place="left"
                                      delayHide={300}/>
                    )}
                    <div className={classes[4]}>
                        {chat_red_text &&
                            <p className={"chat_texts " + (isAutoResponse ? 'autoresponse' : '')} dangerouslySetInnerHTML={{
                                __html: this.decodeHightlight(this.props.state.query, chat_red_text)
                            }}></p>
                        }
                        {!chat_red_text && this.props.chat.message?.length > 0 &&
                            <div className={"chat_texts " + (isAutoResponse ? 'autoresponse' : '')}>
                                <div dangerouslySetInnerHTML={{
                                    __html: this.decodeHightlight(this.props.state.query, ReactDOMServer.renderToStaticMarkup(
                                        <Linkify options={{target: '_blank'}}>{this.props.chat.message}</Linkify>))
                                }}></div>
                            </div>
                        }
                        {this.props.chat.attachments && (
                            <div className="chat_attachments">
                                {this.props.chat.attachments.map((att) => {
                                    const fileExtension = att.extension.toLowerCase();
                                    const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "heic"].includes(fileExtension);
                                    const isVideo = ["mp4", "avi", "mov", "mkv", "webm"].includes(fileExtension);
                                    const isDocument = ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "zip"].includes(fileExtension);

                                    return (
                                        <a key={att.file} href={att.url} target="_blank" rel="noopener noreferrer"
                                           onClick={(event) => this.attachmentClicked(event, att.url)}
                                           className="ml-1">

                                            {isImage ? (
                                                <img src={att.url} height="50" width="50" alt="attachment"/>
                                            ) : isVideo ? (
                                                <i className="fas fa-play-circle fa-3x"></i>
                                            ) : isDocument ? (
                                                <i className="fas fa-file-alt fa-3x"></i>
                                                ) : (
                                                <i className="fas fa-file fa-3x"></i>
                                                )}

                                        </a>
                                    );
                                })}
                            </div>
                        )}
                        <span className="time_date">
                            {formattedDate.format('h:mm A')} {formattedDate.format('z')} | {formattedDateOnly}
                            {name ? ' | ' + name : ''}
                            {this.props.aiLabel ? <span style={{textTransform: 'none'}}>{' | ' + this.props.aiLabel}</span> : ''}
                            {this.props.sentIn ? ' | Sent in ' + this.props.sentIn : ''}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {state: state}
}

export default connect(mapStateToProps)(Chat);
